import IssuePreviewPanel from './IssuePreviewPanel';

export default IssuePreviewPanel;
